/* FREEXAR homepage shared controllers. Component carousels live in their own assets. */
(() => {
  if (window.__freexarHomepageInitialized) return;
  window.__freexarHomepageInitialized = true;

  const initializeHomepage = () => {
    // ── Scroll-reveal ──────────────────────────────────────────────────────────
    const revealElements = document.querySelectorAll('[data-fx-reveal]');

    if ('IntersectionObserver' in window) {
      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('fx-is-visible');
          observer.unobserve(entry.target);
        });
      }, {
        rootMargin: '0px 0px -40px 0px',
        threshold: 0.08,
      });

      revealElements.forEach((element) => revealObserver.observe(element));
    } else {
      revealElements.forEach((element) => element.classList.add('fx-is-visible'));
    }


    // ── Pinned story headings ──────────────────────────────────────────────────
    // Publishes each pinned heading's height so the stage below can clear it.
    const publishHeadingHeight = (heading) => {
      heading.closest('.fx-scroll-story-section')
        ?.style.setProperty('--fx-scroll-story-head-height', `${heading.offsetHeight}px`);
    };

    const headingObserver = 'ResizeObserver' in window
      ? new ResizeObserver((entries) => entries.forEach(({ target }) => publishHeadingHeight(target)))
      : null;

    const observeStoryHeadings = () => {
      document.querySelectorAll('.fx-scroll-story-heading').forEach((heading) => {
        publishHeadingHeight(heading);
        headingObserver?.observe(heading);
      });
    };

    observeStoryHeadings();
    document.addEventListener('shopify:section:load', observeStoryHeadings);

    // ── Nav scroll state ───────────────────────────────────────────────────────

    const nav = document.querySelector('.fx-floating-nav');
    const stickyBar = document.querySelector('.fx-mobile-sticky-bar');
    let scrollFrame = null;

    const updateScrollState = () => {
      scrollFrame = null;
      const scrollY = window.scrollY;
      nav?.classList.toggle('fx-scrolled', scrollY > 30);
      stickyBar?.classList.toggle('fx-visible', scrollY > 450);
    };

    window.addEventListener('scroll', () => {
      if (scrollFrame) return;
      scrollFrame = requestAnimationFrame(updateScrollState);
    }, { passive: true });
    updateScrollState();

    // ── Mobile nav drawer ──────────────────────────────────────────────────────
    const hamburgerButton = document.getElementById('fxNavHamburgerBtn');
    const drawer = document.getElementById('fxMobileDrawer');
    const drawerOverlay = document.getElementById('fxMobileDrawerOverlay');
    const drawerCloseButton = document.getElementById('fxMobileDrawerCloseBtn');
    const drawerLinks = document.querySelectorAll('.fx-mobile-nav-link');

    const openDrawer = () => {
      if (!drawer) return;
      drawer.classList.add('fx-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };

    const closeDrawer = () => {
      if (!drawer) return;
      drawer.classList.remove('fx-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    hamburgerButton?.addEventListener('click', openDrawer);
    drawerOverlay?.addEventListener('click', closeDrawer);
    drawerCloseButton?.addEventListener('click', closeDrawer);
    drawerLinks.forEach((link) => link.addEventListener('click', closeDrawer));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer?.classList.contains('fx-open')) closeDrawer();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeHomepage, { once: true });
  } else {
    initializeHomepage();
  }
})();

